import { useCallback, useEffect, useState } from "@wordpress/element";

import StoreItem from "./StoreItem.jsx";
import { __ } from "@wordpress/i18n";

export default function StoresList({
  list,
  activeId,
  selected: defaultSelected,
  onSelect,
  onChoose,
}) {
  const [selected, setSelected] = useState(defaultSelected);

  const selectStore = useCallback(
    function (store) {
      setSelected(store);
      onSelect && onSelect(store);
    },
    [setSelected, onSelect]
  );

  const chooseStore = useCallback(
    function () {
      onChoose && onChoose(selected);
    },
    [selected, onChoose]
  );

  useEffect(
    function () {
      setSelected(defaultSelected);
    },
    [defaultSelected]
  );

  useEffect(
    function () {
      if (!selected) return;
      const elsSelected = document.getElementsByClassName(
        "stores-results-item--selected"
      );
      if (elsSelected && elsSelected.length > 0) {
        const node = elsSelected[0];
        // node.scrollIntoView();
        node.setAttribute("tabindex", "-1");
        node.focus();
        node.removeAttribute("tabindex");
      }
    },
    [selected]
  );

  if (!list) return null;

  return (
    <div
      className={
        "stores-locator-list" +
        (!list.length ? " stores-locator-list--empty" : "")
      }
    >
      {!list.length ? (
        <span class="empty-message">
          {__("Aucun résultat trouvé", "manitoba-stores")}
        </span>
      ) : (
        <>
          <ol className="stores-results">
            {list.map((store) => (
              <li
                key={store.id}
                className={
                  "stores-results-item" +
                  (store === selected
                    ? " stores-results-item--selected "
                    : "") +
                  (store.id == activeId ? " stores-results-item--active" : "")
                }
              >
                <div
                  className="store-select-trigger"
                  role="button"
                  onClick={() => selectStore(store)}
                >
                  <StoreItem {...store} />
                </div>
              </li>
            ))}
          </ol>
          <div className="stores-actions">
            {!!onChoose && (
              <div className="stores-action-item select-store">
                <button
                  className={
                    "select-store-button" + selected
                      ? "select-store-button--active"
                      : ""
                  }
                  disabled={!selected}
                  onClick={chooseStore}
                >
                  {__("Choisir cette agence", "manitoba-stores")}
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
